// Vietnamese translations for all practice questions and UI elements
export const translations = {
  en: {
    // UI Labels
    mockTestTitle: 'Mock Test',
    mockTestList: 'Available Tests',
    selectTest: 'Select a Test',
    startTest: 'Start Test',
    question: 'Question',
    of: 'of',
    answer: 'Answer',
    submit: 'Submit',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    results: 'Results',
    score: 'Score',
    passed: 'Passed!',
    failed: 'Not Passed',
    correctAnswers: 'Correct Answers',
    incorrectAnswers: 'Incorrect Answers',
    retakeTest: 'Retake Test',
    backToList: 'Back to List',
    loading: 'Loading...',
    error: 'Error',
    selectLanguage: 'Select Language',
    // Authentication Labels
    login: 'Login',
    register: 'Sign Up',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    username: 'Username',
    allFieldsRequired: 'All fields are required',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    invalidEmail: 'Please enter a valid email',
    loginFailed: 'Login failed. Please check your credentials.',
    registerFailed: 'Registration failed. Please try again.',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: 'Don\'t have an account?',
    logout: 'Logout',
    home: 'Home',
    practice: 'Practice',
    mockTests: 'Mock Tests',
    dashboard: 'Dashboard',
    learning: 'Learning',
    contact: 'Contact',
  },
  vi: {
    // UI Labels
    mockTestTitle: 'Bài Kiểm Tra Mô Phỏng',
    mockTestList: 'Các Bài Kiểm Tra Có Sẵn',
    selectTest: 'Chọn Một Bài Kiểm Tra',
    startTest: 'Bắt Đầu Bài Kiểm Tra',
    question: 'Câu Hỏi',
    of: 'của',
    answer: 'Trả Lời',
    submit: 'Gửi',
    next: 'Tiếp Theo',
    previous: 'Quay Lại',
    finish: 'Kết Thúc',
    results: 'Kết Quả',
    score: 'Điểm',
    passed: 'Đã Vượt Qua!',
    failed: 'Chưa Vượt Qua',
    correctAnswers: 'Câu Trả Lời Đúng',
    incorrectAnswers: 'Câu Trả Lời Sai',
    retakeTest: 'Làm Lại Bài Kiểm Tra',
    backToList: 'Quay Lại Danh Sách',
    loading: 'Đang Tải...',
    error: 'Lỗi',
    selectLanguage: 'Chọn Ngôn Ngữ',
    // Authentication Labels
    login: 'Đăng Nhập',
    register: 'Đăng Ký',
    email: 'Email',
    password: 'Mật Khẩu',
    confirmPassword: 'Xác Nhận Mật Khẩu',
    username: 'Tên Người Dùng',
    allFieldsRequired: 'Tất cả các trường bắt buộc',
    passwordsDoNotMatch: 'Mật khẩu không khớp',
    passwordMinLength: 'Mật khẩu phải có ít nhất 6 ký tự',
    invalidEmail: 'Vui lòng nhập email hợp lệ',
    loginFailed: 'Đăng nhập thất bại. Vui lòng kiểm tra thông tin đăng nhập của bạn.',
    registerFailed: 'Đăng ký thất bại. Vui lòng thử lại.',
    alreadyHaveAccount: 'Đã có tài khoản?',
    dontHaveAccount: 'Không có tài khoản?',
    logout: 'Đăng Xuất',
    home: 'Trang Chủ',
    practice: 'Luyện Tập',
    mockTests: 'Bài Kiểm Tra Mô Phỏng',
    dashboard: 'Bảng Điều Khiển',
    learning: 'Học Tập',
    contact: 'Liên Hệ',
  }
};

// Function to get translated text
export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['en'][key] || key;
};

// Function to get translated question
export const getTranslatedQuestion = (question, language) => {
  if (language === 'en') {
    return {
      text: question.text,
      options: question.options,
    };
  }
  
  if (language === 'vi' && question.text_vi) {
    return {
      text: question.text_vi,
      options: question.options_vi || question.options,
    };
  }
  
  return {
    text: question.text,
    options: question.options,
  };
};
